module.exports = __webpack_public_path__ + "static/media/IMG_20200120_083253-min.bd2d8265.jpg";